import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"

export const Pending = ({ confirmation, title, isIBAN }: { confirmation: number; title?: string; isIBAN?: boolean }) => {
  const isIbanPending = /iban.*pending/gi.test(title ?? "")
  let msgText = "the-deposit"
  if (isIBAN) msgText += "_iban"
  return (
    <div className="payment-confirmation">
      <h1 className="uppercase">{title ?? "Exchange Pending"}</h1>
      <p>
        <FormattedMessage id="blockchain" /> {confirmation ?? 0}
      </p>
      <div className="text-center">
        <p>
          * <FormattedMessage id={isIbanPending ? "iban-deposit-pending-text" : msgText} />
        </p>
        <p>
          **{" "}
          <FormattedMessage
            id="order-section"
            values={{
              b: (chunk) => (
                <span className="text-main-main">
                  <Link to="/transactions/exchange" className="hover:!underline">
                    {chunk}
                  </Link>
                </span>
              ),
            }}
          />
        </p>
      </div>
    </div>
  )
}
